var _path, _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.5C0.5 4.35786 3.85786 1 8 1H24C28.1421 1 31.5 4.35786 31.5 8.5V20.5C31.5 24.6421 28.1421 28 24 28H8C3.85786 28 0.5 24.6421 0.5 20.5V8.5Z",
    stroke: "#6EB3FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4226_593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4226_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 20.5L9.33398 12.5L11.334 8.5H20.6673L22.6673 12.5L16.0007 20.5ZM14.4173 11.8333H17.584L16.584 9.83333H15.4173L14.4173 11.8333ZM15.334 17.6167V13.1667H11.634L15.334 17.6167ZM16.6673 17.6167L20.3673 13.1667H16.6673V17.6167ZM19.0673 11.8333H20.834L19.834 9.83333H18.0673L19.0673 11.8333ZM11.1673 11.8333H12.934L13.934 9.83333H12.1673L11.1673 11.8333Z",
    fill: "#6EB3FA"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.d18a9c9c303774058bdd26490e3743ca.svg";
export { ForwardRef as ReactComponent };